import React, { useEffect, useMemo, useRef, useState } from "react";
import Popup from "./Popup";
import {
  caseStatus,
  DATE_TIME_FORMAT,
  fileNameType,
  quotationStatusColor,
  quotationStatusLabel,
  quotationStatus as quotationStatusConst,
} from "app/constants";
import moment from "moment";
import { commonServices } from "app/services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { formatIndex, getBaseName, getFileExtension } from "../../../../utils";

function QuotationCell(props) {
  const {
    width,
    quotationStatus,
    quotationInfo,
    caseInfo,
    highlight = false,
    setDownloading,
  } = props;
  const [anchor, setAnchor] = useState(null);
  const ref = useRef();
  const disabledChangeStatus = useMemo(() => {
    return (
      (caseInfo?.caseStatus === caseStatus.completed ||
        caseInfo?.caseStatus === caseStatus.lost) &&
      quotationStatus !== quotationStatusConst.submitted
    );
  }, [caseInfo, quotationStatus]);

  useEffect(() => {
    if (highlight) {
      ref?.current?.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [highlight]);

  const handleLeftClickQuotation = () => {
    const caseId = caseInfo?.caseId || "";
    const fileType = fileNameType["quotation"];
    const customerName = caseInfo?.customer?.companyNameKanji || "";
    const timeStamp = moment().format("YYYYMMDDHHmmss");

    if (quotationInfo.fileInfo) {
      const files = Array.isArray(quotationInfo.fileInfo) ? quotationInfo.fileInfo : [quotationInfo.fileInfo];

      setDownloading(true);

      Promise.all(
        files.map((file, index) =>
          new Promise((resolve) => {
            setTimeout(() => {
              const name = file.fileName
                ? getBaseName(file.fileName)
                : `${fileType}_${caseId}_${customerName}_${formatIndex(index + 1)}_${timeStamp}`;

              const extension = getFileExtension(file);
              if (extension === "zip") {
                commonServices
                  .downloadWithFileId(file._id, extension, name)
                  .finally(() => resolve());
              } else {
                commonServices
                  .downloadPDFWithFileId(file._id, name)
                  .finally(() => resolve());
              }
            }, index * 500);
          })
        )
      ).finally(() => setDownloading(false));
    }
  };

  const handleRightClickQuotation = (e) => {
    e.preventDefault();
    if (disabledChangeStatus) return;
    setAnchor(e.target);
  };

  return (
    <>
      <div
        ref={ref}
        className={`h-full border border-[#B3B3B3] px-2 py-4 shrink-0 ${
          highlight && "bg-yellow-100"
        }`}
        style={{
          width: width,
        }}
      >
        <p className="text-sm leading-[18px] tracking-[.2em] truncate text-center">
          <button
            style={{
              color: quotationStatusColor[quotationStatus],
              cursor: "pointer",
            }}
            onClick={handleLeftClickQuotation}
            onContextMenu={handleRightClickQuotation}
          >
            {quotationStatusLabel[quotationStatus]}
          </button>
        </p>
      </div>

      <Popup
        id={`quotation-${quotationInfo._id}`}
        anchor={anchor}
        open={Boolean(anchor)}
      >
        <div className="flex flex-col">
          <button
            className="bg-[#c7c2c2] w-7 h-7 rounded-full ml-auto flex items-center justify-center"
            onClick={() => setAnchor(null)}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <p className="flex gap-2">
            最終更新日:{" "}
            {moment(
              caseInfo?.updateQuotationTime || quotationInfo?.updatedAt
            ).format(DATE_TIME_FORMAT)}
          </p>
        </div>
      </Popup>
    </>
  );
}

export default QuotationCell;
